import { useEffect, useState } from 'react';

import { useQuery } from '@apollo/client';
import { ISelectOption } from '@smartshell/ui-kit';
import { useNavigate, useSearchParams } from 'react-router-dom';

import { HOST_GROUPS } from 'schemas';

import { IFilters, IHostGroupsResponse, IReturnValue } from './interfaces';
import { getSearchParams } from './utils';

export const useTariffFilters = (): IReturnValue => {
  const [activeFilters, setActiveFilters] = useState<IFilters>({
    is_active: false,
    has_fixed_finish_time: false,
    use_global_discounts: false,
    host_group: null,
  });

  const [options, setOptions] = useState<Array<ISelectOption>>([]);

  const { data } = useQuery<IHostGroupsResponse>(HOST_GROUPS);

  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  useEffect(() => {
    if (!data) return;

    const mappedHostGroups = data.hostGroups.map(({ title, id }) => ({
      title,
      value: `${id}`,
    }));

    setOptions(mappedHostGroups);
  }, [data, setOptions]);

  useEffect(() => {
    if (options.length) {
      const is_active = searchParams.get('is_active');
      const has_fixed_finish_time = searchParams.get('has_fixed_finish_time');
      const use_global_discounts = searchParams.get('use_global_discounts');
      const host_group = searchParams.get('host_group') || [];

      const selectedHostGroup = options.find(
        (option) => option.value === host_group
      );

      setActiveFilters({
        is_active: is_active === 'true',
        has_fixed_finish_time: has_fixed_finish_time === 'true',
        use_global_discounts: use_global_discounts === 'true',
        host_group: selectedHostGroup ?? null,
      });
    }
  }, [options]);

  useEffect(() => {
    if (options.length && activeFilters) {
      navigate(
        {
          search: getSearchParams(activeFilters),
        },
        { replace: true }
      );
    }
  }, [activeFilters, options]);

  return {
    host_groups: options,
    activeFilters,
    setActiveFilters,
  };
};
